export default __webpack_public_path__ + "static/media/contratar_01.44a8ebaa.jpg";